import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const STATUS = {
  Open: { bg: "#FEF3C7", color: "#854D0E" },
  "In Progress": { bg: "#DBEAFE", color: "#1E40AF" },
  Closed: { bg: "#DCFCE7", color: "#166534" },
};

export default function Audits() {
  const { data, siteNames } = useHSE();
  const avgScore = data.audits.length ? Math.round(data.audits.reduce((a, b) => a + Number(b.score || 0), 0) / data.audits.length) : 0;
  const totalFindings = data.audits.reduce((a, b) => a + Number(b.findings || 0), 0);

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <Stat label="Monthly Audits" value={data.audits.length} />
      <Stat label="Closed Audits" value={data.audits.filter((a) => a.status === "Closed").length} tone="safe" />
      <Stat label="Avg Score" value={`${avgScore}%`} tone={avgScore >= 85 ? "safe" : "warning"} />
      <Stat label="Total Findings" value={totalFindings} tone="warning" />
    </div>
  );

  return (
    <RegisterPage
      title="Monthly Internal Audit"
      subtitle="Construction monthly internal audit register with score, findings, actions and final summary"
      storeKey="audits"
      idPrefix="AUD"
      topPanels={Top}
      columns={[
        { key: "id", label: "Audit ID" },
        { key: "date", label: "Audit Date" },
        { key: "site", label: "Site" },
        { key: "monthYear", label: "Audit Month" },
        { key: "auditArea", label: "Audit Area / Department" },
        { key: "complianceStatus", label: "Compliance Status" },
        { key: "findingsObservations", label: "Findings / Observations" },
        { key: "correctiveAction", label: "Corrective Action" },
        { key: "responsible", label: "Responsible Person" },
        { key: "targetDate", label: "Target Date" },
        { key: "score", label: "Final Score", render: (r) => <span className="tabular font-semibold">{r.score}%</span> },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS }}
      formFields={[
        { key: "id", label: "Audit ID" },
        { key: "date", label: "Audit Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "monthYear", label: "Audit Month / Year" },
        { key: "auditArea", label: "Audit Area / Department" },
        { key: "type", label: "Audit Type", type: "select", options: ["Monthly Internal Audit"] },
        { key: "auditor", label: "Auditor" },
        { key: "checklistItems", label: "Checklist Items", type: "textarea", full: true },
        { key: "complianceStatus", label: "Compliance Status" },
        { key: "findingsObservations", label: "Findings / Observations", type: "textarea", full: true },
        { key: "correctiveAction", label: "Corrective Action", type: "textarea", full: true },
        { key: "responsible", label: "Responsible Person" },
        { key: "targetDate", label: "Target Date", type: "date" },
        { key: "findings", label: "Findings (count)", type: "number" },
        { key: "score", label: "Final Audit Score (%)", type: "number" },
        { key: "finalSummary", label: "Final Audit Summary", type: "textarea", full: true },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed"] },
      ]}
    />
  );
}

function Stat({ label, value, tone = "neutral" }) {
  const c = { safe: "#54A57B", warning: "#FFB517", critical: "#DC2626", neutral: "#183C55" }[tone];
  return (
    <div className="command-card p-3.5 border-l-4" style={{ borderLeftColor: c }}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{value}</div>
    </div>
  );
}
